

    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../controlador';
    import { Pago } from '@/__env/lib/Ventas/Pagos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Cliente() { return this.Controlador.Pedido.Cliente; }
        public get Envio() { return this.Controlador.Pedido.Envio; }
        public get Pagos() { return this.Controlador.Pedido.Pagos; }

        public async Desvincular( pago: Pago )
        {
            if ( await Utiles.Mensajes.SiNo( 'Desvincular del pedido', 'El pago se desvinculará de este pedido. ¿Continuar?' ) )
            {
                let e = await this.Pedido.DesvincularPago( pago.Id );
                if ( e )
                {
                    Utiles.Notificaciones.Completado( 'Completado!' );
                    await Wait( 500 );
                    window.location.reload();
                } else
                {
                    Utiles.Notificaciones.Error('');
                }
                
            }
        }

        public async Comprobante( pago: Pago )
        {
            if ( pago.Comprobante )
            {
                window.open( pago.Comprobante )
            }
        }

        public async Validar( pago: Pago )
        {
            this.Controlador.Vista.BarraDerecha.Datos = pago;
            this.Controlador.Vista.BarraDerecha.Modo = 'validar_pago';
        }
    }
